export const SHOOTING_ACTIVE_STORAGE_KEY = 'dl_shooting_active';

export type GuideSceneProgress = {
  status?: string;
  takes?: unknown[];
};

export function hasGuideShootingProgress(scenes: GuideSceneProgress[] | undefined): boolean {
  if (!scenes?.length) return false;
  return scenes.some(
    (s) =>
      (s.takes?.length ?? 0) > 0 ||
      (s.status != null && s.status !== 'pending'),
  );
}

/** Première étape à afficher (0 = activation caméra). */
export function resolveResumeStep(scenes: GuideSceneProgress[]): number {
  if (!scenes.length) return 0;
  if (!hasGuideShootingProgress(scenes)) return 0;

  for (let i = 0; i < scenes.length; i++) {
    const takes = scenes[i].takes as Array<{ isSelected?: boolean }> | undefined;
    const hasTake = (takes?.length ?? 0) > 0;
    const hasSelected = takes?.some((t) => t.isSelected) ?? false;
    if (!hasTake || !hasSelected) return i + 1;
  }

  return scenes.length;
}

export function setShootingSessionActive(active: boolean): void {
  if (typeof sessionStorage === 'undefined') return;
  if (active) {
    sessionStorage.setItem(SHOOTING_ACTIVE_STORAGE_KEY, '1');
  } else {
    sessionStorage.removeItem(SHOOTING_ACTIVE_STORAGE_KEY);
  }
}

export function isShootingSessionActive(): boolean {
  if (typeof sessionStorage === 'undefined') return false;
  return sessionStorage.getItem(SHOOTING_ACTIVE_STORAGE_KEY) === '1';
}

export function stripNewPurchaseFromUrl(): void {
  if (typeof window === 'undefined') return;
  const url = new URL(window.location.href);
  if (!url.searchParams.has('new')) return;
  url.searchParams.delete('new');
  const next = `${url.pathname}${url.search}${url.hash}`;
  window.history.replaceState({}, '', next);
}
